
import { companyLogoHandler, privacyModeTextFormatterMixin } from '@/mixins';
import FormatterService from "@/service/FormatterService";
import CdnService from "../../service/CdnService";

    export default {

        name: 'ShareDetails',
        mixins: [ companyLogoHandler, privacyModeTextFormatterMixin, ],
        props: {
            share: Object,
            companyLogo: String
        },

        data() {
            return {
                companyLogoUrl: this.companyLogo,
                format: new FormatterService()
            }
        },

        methods: {
            getCompanyLogoClass(logo) {
                return (logo && logo != null) ? 'company-logo' : 'company-logo-invalid'
            },
        },

        computed: {
            showMasterData() {
                return this.share.name
                    || this.share.company
                    || this.share.companyLogo
                    || this.share.symbol
                    || this.share.primaryMarketMic
                    || this.share.wkn
                    || this.share.isin
                    || this.share.type
                    || this.share.sector
                    || this.share.industry
                    || this.share.marketcap
                    || this.share.country
                    || this.share.currency
                    || this.share.employees
                    || this.share.address
            },
            visibleForType() {
                return ![this.$t('component.share.shareDetails.ipoDate'), this.$t('component.share.shareDetails.currency')].includes(this.share.type.toUpperCase())
            }
        },

        created() {
            this.cdnService = new CdnService()
        }

    }
